<template lang="pug">
    #search
        input.text(type="text" placeholder="Поиск..." v-model="searchString" v-on:keyup="dropdown"  v-on:keyup.enter="search")
        md-button.small.md-icon-button.close.md-dense(@click="resetFilter" v-if="searchString.length"): md-icon close
        //ul.dropdown.md-elevation-2(v-if="showSearchDropdown && searchString")
            li(@click="filter" v-for="freight in freights") Груз #[md-chip {{freight.traking_number}}]
            li(@click="filter") Поиск "{{ searchString }}"
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                searchString: '',
                showSearchDropdown: false,
            }
        },
        watch: {},
        computed: {},
        methods: {
            dropdown() {
              if ((this.searchString && this.searchString.length > 4) || this.searchString.length === 0)
                  this.search();
            },
            search() {
                this.showSearchDropdown = true;
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: { search: this.searchString }
                });
                this.$root.$emit('refresh-table', 'storekeepers-freights-table');
            },
            resetFilter() {
                this.showSearchDropdown = false;
                this.searchString = '';
                this.$router.push({name: this.$route.name, params: this.$route.params, query: {}});
                this.$root.$emit('refresh-table', 'storekeepers-freights-table');
            }
        },
        created() {
            if (this.$route.query.search) {
                this.searchString = this.$route.query.search;
                this.search();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FreightsToolbar.vue?538cdf41